module.exports = __webpack_public_path__ + "static/img/service_monijisuan.4e8fecd5.png";